import React, { useState, useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { closeAddressDialog } from 'reducers/PersonDialogsReducer';
import Dialog from 'components/RMSDialog';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { handleError } from 'reducers/ErrorReducer';
import AddressHistory from './AddressHistory';
import AddressSOPs from './AddressSOPs';
import AddressParties from './AddressParties';
import AddressZones from './AddressZones';
import { getAddressDetails, getAddressSops } from 'reducers/AddressReducer';
import AddressEdit from './AddressEdit';
import AddressCoordinates from './AddressCoordinates';
import AddressPrePlan from './AddressPrePlan';
import RMSAttachments2 from 'components/RMSAttachments/RMSAttachments2';
import {
  resetDuplicateList,
  setDuplicateFoundBtn,
  setDuplicateModal,
} from 'reducers/ui/UiModalReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer';

const useStyles = makeStyles((theme) => ({
  content: {
    margin: -theme.spacing(3),
  },
  closeButton: { color: theme.button.color },
  RedTabs: {
    color : 'red'
  }
}));

function Address(props) {
  const classes = useStyles();
  const { ptsAddressID, copyAddress } = props;
  const [tab, setTab] = useState('edit');
  const [address, setAddress] = useState(null);
  const mountedRef = useRef(true);
  const newAddress = Boolean(!ptsAddressID || copyAddress);
  const dataUpdate = useSelector((state) => state.dataUpdate);
  const [canSave, setCanSave] = useState(false);
  const addressPermission = getFullPermissions('globals', 'Addresses', 'any');
  const [countOfSops, setCountOfSops] = useState(0);
  useEffect(() => {
    if (props.tab) setTab(props.tab);
    getAddressData();
    if(!newAddress){
      getSOPs();
    }
    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line
  }, [props.tab, dataUpdate]);
  useEffect(() => {
    if (newAddress) {
      setCanSave(true);
    } else {
      if (addressPermission.Edit) {
        setCanSave(true);
      } else {
        setCanSave(false);
      }
    }
  }, [newAddress]);
  const getAddressData = async () => {
    try {
      const data = await getAddressDetails(ptsAddressID);
      if (!mountedRef.current) return;
      data?.data.length && setAddress(data.data[0]);
    } catch (err) {
      props.handleError(err, 'Error receiving event location data.');
    }
  };

  const getSOPs = async () => {
    try {
      const sops = await getAddressSops(ptsAddressID);
      if (!mountedRef.current) return;
      setCountOfSops(processSOPData(sops).length);
    } catch (err) {
      props.handleError(err, 'Error receiving event location data.');
    }
  };

  const processSOPData = (data) => {
    return data.map((row) => {
      if (row.IsDeleted === false) return { ...row, id: row.ROWGUID };
    });
  };

  const handleSOPChange = (newCount) => {
    setCountOfSops(newCount);
  };

  const close = (data) => {
    props.closeAddressDialog(data);
    props.setDuplicateModal(false);
    props.setDuplicateFoundBtn(false);
    resetDuplicateList();
  };
  const renderActions = () => {
    return (
      <>
        <Button color="primary" onClick={close} className={classes.closeButton}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };
  const getTitle = () => {
    const title = newAddress ? 'Add Address' : 'Edit Address';
    return newAddress || addressPermission.Edit ? (
      `${title}`
    ) : (
      <div className="d-flex" style={{ width: '100%', justifyContent: 'left', textAlign: 'left' }}>
        <span style={{ flex: 0.5 }}>{title}</span>
        <span style={{ flex: 0.5, color: 'red', fontWeight: 'bold', fontSize: '21px' }}>
          VIEW ONLY
        </span>
      </div>
    );
  };
  return (
    <Dialog toolbar onClose={close} title={getTitle()} actions={renderActions()} fullScreen>
      <div className={classes.content}>
        <Paper square>
          <Tabs value={tab} onChange={(ev, val) => setTab(val)}>
            <Tab label="Edit Address" value="edit" />
            <Tab label="Attachments" value="attachments" disabled={newAddress} />
            <Tab label="Coordinates" value="coordinates" disabled={newAddress} />
            <Tab label="History" value="history" disabled={newAddress} />
            <Tab label="Parties" value="parties" disabled={newAddress} />
            <Tab label="Pre-Plan" value="pre-plan" disabled={newAddress} />
            <Tab label={countOfSops > 0 ? `SOPs (${countOfSops})` : 'SOPs'} value="sops" disabled={newAddress} className={countOfSops > 0 ? classes.RedTabs : ''}/>
            <Tab label="Zones" value="zones" disabled={newAddress} />
          </Tabs>
        </Paper>
        {tab === 'edit' && (
          <AddressEdit ptsAddressID={ptsAddressID} canSave={canSave} copyAddress={copyAddress} />
        )}
        {!newAddress && (
          <>
            {tab === 'history' && <AddressHistory ptsAddressID={ptsAddressID} canSave={canSave} />}
            {tab === 'sops' && <AddressSOPs ptsAddressID={ptsAddressID} canSave={canSave} onSOPChange={handleSOPChange} />}
            {tab === 'parties' && <AddressParties ptsAddressID={ptsAddressID} canSave={canSave} />}
            {tab === 'zones' && (
              <AddressZones ptsAddressID={ptsAddressID} canSave={canSave} address={address} />
            )}
            {tab === 'attachments' && (
              <RMSAttachments2 type="Address" id={ptsAddressID} permissions={addressPermission} />
            )}
            {tab === 'coordinates' && (
              <AddressCoordinates ptsAddressID={ptsAddressID} canSave={canSave} />
            )}
            {tab === 'pre-plan' && <AddressPrePlan ptsAddressID={ptsAddressID} canSave={canSave} />}
          </>
        )}
      </div>
    </Dialog>
  );
}

export default connect(null, {
  closeAddressDialog,
  handleError,
  setDuplicateFoundBtn,
  setDuplicateModal,
})(Address);
